import * as React from "react";
function SvgChevronUp(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={4}
        d="M30 23L16 9 2 23"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgChevronUp);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
